<template>
    <!-- <Navbar/> -->
    <!-- <SideBar/> -->

    <div class="main-content">
            <div class="progress-spinner" v-if="spinnerLoadingStatus">
                <ProgressSpinner></ProgressSpinner>
            </div>

    <div class="grid">        
        <div class="sm:col-12 md:col-6 lg:col-3">
          <div class="flex ">
            <div class="flex-initial flex justify-content-center w-full"> 
                <div class="surface-card shadow-2 p-3 border-round-xl  w-full mt-4 mr-2 ml-3">
                    
                  <div class="field  mt-2 ml-2 w-full">
                    <i class="pi pi-wrench mr-1 font-medium" style="font-size: 1.5rem; color:#e50000"></i>  
                    <label class="text-3xl font-medium ml-2"> {{formatNumber(pendingInstallationCount)}}</label> <br>

                    <label class="text-500">Pending Installation</label>
                  </div>
                  <div class="w-full pt-4">
                    <MeterGroup :value="pendingInstallationMeter" class="mx-2"/>
                  </div>
                </div>
            </div>
          </div>
        </div>

        <div class="sm:col-12 md:col-6 lg:col-3">
          <div class="flex ">
            <div class="flex-initial flex justify-content-center w-full"> 
                <div class="surface-card shadow-2 p-3 border-round-xl  w-full mt-4 mx-2 sm:ml-3 sm:mr-2">
                    <div class="field mt-2 ml-2 w-full">
                        <i class="pi pi-cog pi-spin mr-1" style="font-size:1.5rem; color:#3383ff;"></i> 
                        <label class="text-3xl font-medium ml-2" >{{formatNumber(servicingDue)}}</label><br>
                        <label class="text-500">Servicings</label>
                    </div>
                    <div class="w-full pt-4">
                        <MeterGroup :value="servicingMeter" class="mx-2"/>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <div class="sm:col-12 md:col-6 lg:col-3">
          <div class="flex ">
            <div class="flex-initial flex justify-content-center w-full"> 
                <div class="surface-card shadow-2 p-3 border-round-xl  w-full mt-4 ml-2 md:ml-3 sm:ml-3 mr-2">
                    <div class="field  mt-2 ml-2 w-full">
                        <i class="pi pi-money-bill mr-1" style="font-size:1.5rem; color:#1ca500"></i> 
                        <label class="text-3xl font-medium ml-2">{{formatNumber(cmPendingBillCount)}}</label> <br>
                        <label class="text-500">Servicings pending to be billed</label>
                    </div>
                    <div class="mt-3">
                        <label class="text-lg">Value</label><br>
                        <hr class="hr-style mr-2">
                        <div class="flex justify-content-between flex-wrap mt-1">
                            <div class="flex align-items-center justify-content-center text-base">
                                <label class="mr-2">Ex-Gst: </label>
                                <label class="bg-green-100 border-round px-1 py-1">{{formatCurrency(pendingBillExGst)}}</label>
                            </div>
                            <div class="flex align-items-center justify-content-center mr-2">
                                <label class="mr-2">GST: </label>
                                <label class=" bg-green-100 border-round px-1 py-1">{{formatCurrency(pendingBillGst)}}</label>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
          </div>
        </div>

        <div class="sm:col-12 md:col-6 lg:col-3">
          <div class="flex ">
            <div class="flex-initial flex justify-content-end w-full "> 
                <div class="flex align-items-center justify-content-center text-base ml-2 md:ml-3 sm:ml-3 mr-3 border-2 border-dashed border-300 border-round-xl border-solid mt-4">
                    <div class="field mt-2 mr-4 ml-3 mb-4">
                        <label class="text-xl font-medium">Servicing Bills</label>
                        <router-link to="/new-servicing-bill" rel="noopener">
                            <Button label="Create Bill" icon="pi pi-plus" raised class="px-4 mt-3 mr-3 w-full" />
                        </router-link>
                        <router-link to="/servicing-bills" rel="noopener">
                            <Button label="CMC Bills" icon="pi pi-list" text raised class="w-full px-4 mr-3 mt-3" />
                        </router-link>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <!-- new tab view -->
        <div class="sm:col-12 md:col-12 lg:col-12">
          <div class="flex ">
            <div class="flex-initial flex justify-content-center w-full ml-3 mr-3 "> 
                <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 ">

                    <TabView class="tabview-custom" @tab-click="toggleTabs">
                        <TabPanel>
                            <template #header>
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-wrench" style="font-size: 1.5rem; color: #e50000"></i>

                                    <span class="font-bold white-space-nowrap">Installations</span>
                                </div>
                            </template>                            
                                <div class="field font-medium text-lg w-full">
                                    <div class="flex justify-content-between flex-wrap">
                                        <div class="flex align-items-center justify-content-center font-semibold text-lg  ml-2">                                        
                                                Equipment Installations                                       
                                        </div>
                                        <div class="flex align-items-center justify-content-center mr-3 mt-2">
                                                                    
                                            <Button label="Add Installation" size="small" raised @click="showDialog" :disabled="installationBtn"/>
                                        </div>                                     
                                    </div>
                                    <div class="flex justify-content-between flex-wrap">
                                        <div class="flex align-items-center justify-content-center">                                        
                                                <Button label="Export" icon="pi pi-file-export" raised  size="small" class="ml-2" @click="exportCSV" v-tooltip.top="'Excel format'"/>                                       
                                        </div>
                                        <div class="flex align-items-center justify-content-center"> 
                                            <label class="mt-2 mr-1 text-500">Next CMC: </label>
                                            <Calendar v-model="startDate" placeholder="Start date" class="mr-2 mt-2" />
                                            <Calendar v-model="endDate" placeholder="End date" class="mr-2 mt-2"/>           

                                            <!-- <InputText v-model="filters['global'].value" placeholder="Keyword Search" class=" mr-3 mb-0 mt-2" size="small"/> -->
                                            <Button class="ml-2" icon="pi pi-filter" severity="success" raised size="small" @click="globalFilter" v-tooltip.top="'Search'"/>
                                            <Button class="ml-2" icon="pi pi-filter-slash" size="small" outlined raised severity="success" @click="clearFilter" v-tooltip.top="'Clear result'"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="field col">
                                    <DataTable ref="installationsList" exportFilename="installed_equipments_list" :value="tableData" stripedRows  size="small" :loading="tableLoading" v-model:filters="filters"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30rem" filterDisplay="menu" :globalFilterFields="['item','location','poNo', 'partSerialNo', 'nextCmc.status']">

                                        <template #empty>
                                            <div class="flex ">
                                                <div class="flex-initial flex justify-content-center w-full"> 
                                                    <label class="font-medium" >No data</label>
                                                </div>
                                            </div>
                                        </template>
                                        <Column header="Sl No." >
                                            <template #body="slotProps">
                                                {{slotProps.index + 1}}
                                            </template>
                                        </Column>
                                        <Column field="location" header="Location" frozen="true">
                                            <template #body="slotProps">  
                                                {{slotProps.data.location}}
                                            </template>
                                            <template #filter="{ filterModel }">
                                                <!-- <Dropdown v-model="filterModel.value" :options="locations" placeholder="Select One" class="p-column-filter" showClear filter >
                                                    <template #option="slotProps">
                                                        {{slotProps.option}}
                                                    </template>
                                                </Dropdown> -->
                                                <MultiSelect v-model="filterModel.value" :options="locations" filter placeholder="Select One" class="p-column-filter">
                                                    <template #option="slotProps">
                                                        {{slotProps.option}}
                                                    </template>
                                                </MultiSelect>
                                            </template>
                                        </Column>   
                                        <Column field="item" header="Item">
                                            <template #body="slotProps">
                                                {{slotProps.data.item}}
                                            </template>
                                            <template #filter="{ filterModel }">
                                                <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
                                            </template>
                                        </Column>
                                        <Column field="poNo" header="PO No.">
                                            <template #body="slotProps">
                                                {{slotProps.data.poNo}}
                                            </template>
                                            <template #filter="{ filterModel }">
                                                <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
                                            </template>
                                        </Column>
                                        <Column field="installedQty" header="Quantity"></Column>
                                        <Column field="manufacturer.name" header="Manufacturer"></Column>
                                        <Column field="modelNo" header="Model No"></Column>
                                        <Column field="partSerialNo" header="Serial No">
                                            <template #body="slotProps">
                                                {{slotProps.data.partSerialNo}}
                                            </template>
                                            <template #filter="{ filterModel }">
                                                <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by serial no" />
                                            </template>
                                        </Column>
                                        <Column field="installationDate" header="Installation Date"></Column>
                                        <Column field="nextCmc.cmcDate" dataType="date" header="Next CMC">
                                            <template #body="slotProps">   
                                                <div v-if="slotProps.data.nextCmc.cmcDate!=null">
                                                    {{formatDate(slotProps.data.nextCmc.cmcDate)}}
                                                </div>
                                                <div v-if="slotProps.data.nextCmc.cmcDate==null">
                                                    {{slotProps.data.nextCmc.cmcDate}}
                                                </div>
                                            </template>
                                        </Column>
                                        <Column header="CMC" field="nextCmc.status">
                                            <template #body="slotProps"> 
                                                <Tag :value="slotProps.data.nextCmc.status" :severity="getCmcSeverity(slotProps.data.nextCmc.status)"/>
                                            </template>
                                            <template #filter="{ filterModel }">
                                                <Dropdown v-model="filterModel.value" :options="cmcStatusOptions" placeholder="Select One" class="p-column-filter" showClear>
                                                    <template #option="slotProps">
                                                        <Tag :value="slotProps.option" :severity="getCmcSeverity(slotProps.option)" />
                                                    </template>
                                                </Dropdown>
                                            </template>                
                                        </Column>
                                        <Column header="CMC Year" field="nextCmc.year" exportable="true" hidden="true"></Column>
                                        <Column header="CMC Qtr" field="nextCmc.quarter" exportable="true" hidden="true"></Column>
                                        <Column hidden exportable="true" field="userContact" header="User Cont."></Column>
                                        <Column header="CMC">
                                            <template #body="slotProps">                                          
                                                <router-link :to="{
                                                    name: 'equipment-cmc-details',
                                                    params:{
                                                        id:slotProps.data.id,
                                                    }
                                                }" rel="noopener">
                                                    <Button label="CMC" text raised size="small" v-tooltip.top="'CMC details of equipment'"/>
                                                </router-link>
                                            </template>
                                        </Column>
                                        <Column header="Type" field="nextCmc.type">

                                        </Column>                                    
                                        <Column header="Actions">
                                            <template #body="slotProps">
                                                <Button icon="pi pi-trash" size="small" text rounded raised severity="danger" @click="showDeleteDialog(slotProps.data, 1)" v-tooltip.top="'Delete Installation'"></Button>
                                                <Button icon="pi pi-pencil" size="small" text raised @click="updateInstallationDialog(slotProps.data)" v-tooltip.top="'Update Installation'"></Button>
                                            </template>
                                        </Column>                                    
                                    </DataTable>                    
                                </div>
                            
                        </TabPanel>
                        <TabPanel>
                            <template #header>
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-cog" style="font-size: 1.5rem; color: #3383ff"></i>
                                    <span class="font-bold white-space-nowrap">Servicings</span>
                                </div>
                            </template>

                            <div class="flex justify-content-between flex-wrap mb-2">
                                <div class="flex align-items-center justify-content-center font-semibold text-lg  ml-2">                                        
                                    Equipment Servicings                                       
                                </div>
                                <div class="flex align-items-center justify-content-center">                                        
                                        <Button label="Export" icon="pi pi-file-export" raised  size="small" class="ml-2" @click="exporServicingtCSV" v-tooltip.top="'Excel format'"/>
                                </div>
                            </div>

                            <DataTable ref="servicingsList" exportFilename="equipments_servicings_list" :value="servicingsData" stripedRows  size="small" :loading="table2Loading" v-model:filters="filters2"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30rem" filterDisplay="menu" :globalFilterFields="['item', 'order', 'partSrNo',  'partSrNo','location','serviceType','billStatus']">

                                <Column header="Sl No." >
                                    <template #body="slotProps">
                                        {{slotProps.index + 1}}
                                    </template>
                                </Column>
                                <Column header="Equipment" field="item">
                                    <template #body="slotProps">
                                        {{slotProps.data.item}}
                                    </template>
                                    <template #filter="{ filterModel }">
                                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
                                    </template>
                                </Column>
                                <Column header="Order" field="order">
                                    <template #body="slotProps">
                                        {{slotProps.data.order}}
                                    </template>
                                    <template #filter="{ filterModel }">
                                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by Order No." />
                                    </template>
                                </Column>  
                                <Column header="Pt/Sr No." field="partSrNo">
                                    <template #body="slotProps">
                                        {{slotProps.data.partSrNo}}
                                    </template>
                                    <template #filter="{ filterModel }">
                                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by part/serial no." />
                                    </template>
                                </Column>                                 
                                <Column header="Location" field="location"></Column> 
                                <Column header="Centre" field="centre"></Column> 
                                <Column header="Department" field="department"></Column> 
                                <Column header="Type" field="serviceType">
                                    <template #body="slotProps">
                                        <Tag :value="slotProps.data.serviceType" :severity="getCmcTypeSeverity(slotProps.data.serviceType)" />
                                    </template>
                                    <template #filter="{ filterModel }">
                                        <Dropdown v-model="filterModel.value" :options="cmcTypeOptions" placeholder="Select type" class="p-column-filter" showClear>
                                            <template #option="slotProps">
                                                <Tag :value="slotProps.option" :severity="getCmcTypeSeverity(slotProps.option)" />
                                            </template>
                                        </Dropdown>
                                    </template>
                                </Column> 
                                <Column header="Year" field="year"></Column>
                                <Column header="Quarter" field="quarter"></Column>
                                <Column header="Start Date/End Date" field="startDate">
                                    <template #body="slotProps">
                                        {{slotProps.data.startDate}}/{{slotProps.data.endDate}}
                                    </template>
                                </Column> 
                                <Column header="Billing" field="billStatus">
                                    <template #body="slotProps">
                                        <div>
                                            <Tag :value="slotProps.data.billStatus" :severity="getBillSeverity(slotProps.data.billStatus)" />
                                        </div>
                                        </template>
                                        <template #filter="{ filterModel }">
                                            <Dropdown v-model="filterModel.value" :options="billStatusOptions" placeholder="Select status" class="p-column-filter" showClear>
                                                <template #option="slotProps">
                                                    <Tag :value="slotProps.option" :severity="getBillSeverity(slotProps.option)" />
                                                </template>
                                            </Dropdown>
                                        </template>     

                                </Column> 
                                <Column header="Bills" field="bills">
                                    <template  #body="slotProps">
                                        <div v-if="slotProps.data.billStatus=='Pending'">
                                            NA
                                        </div>
                                        <div v-if="slotProps.data.billStatus=='Completed'">
                                            {{slotProps.data.bills}}
                                        </div>
                                    </template>
                                </Column>  
                                <Column header="Action">
                                    <template  #body="slotProps">
                                        <div class="flex" v-if="slotProps.data.billStatus=='Pending'">
                                            <Button icon="pi pi-trash" text raised severity="danger" @click="showDeleteDialog(slotProps.data, 2)" v-tooltip.top="'Delete Servicing'" />
                                            <Button icon="pi pi-pencil" text raised  v-tooltip.top="'Update'" @click="updateCmcDialog(slotProps.data)" />

                                        </div>
                                        <div class="flex" v-if="slotProps.data.billStatus=='Completed'">
                                            <Button  icon="pi pi-trash" text raised severity="danger" disabled />
                                            <Button icon="pi pi-pencil" text raised  v-tooltip.top="'Update'" disabled />
                                        </div>
                                    </template>
                                </Column>                         

                            </DataTable>
                        </TabPanel>
                    </TabView>

                </div>
            </div>
          </div>
        </div>
        <!-- tab view end -->

    </div>

        <!-- dialog start -->
        <Dialog :visible="dialogVisibility"  :modal="true" :style="{ width: '55rem' }" :closable="false" :dismissableMask="true">
            <template #header >
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center text-xl font-semibold">
                        {{dialogHeader}}
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>                                    
                </div>
            </template>

            <hr class="w-full"> 
            <div class="mb-4">
                <label class="text-lg font-semibold mb-2">
                    Equipment Details
                    <span class="text-sm text-400">Options marked as <span class="text-red-500">*</span> are mandatory</span>
                </label>
            </div>

            <div class="formgrid grid mt-2">
                <div class="field col">
                    <label class="w-full font-semibold">Department Order:<span class="text-red-500">*</span> </label>
                    <Dropdown class="w-full mb-3" v-model="selectedDeptOrder" filter :options="deptOrdersOnly" optionLabel="poNo" placeholder="Select an order" showClear @change="filterEquipments" v-if="!updateStatus" :disabled="updateStatus"/>

                    <InputText v-model="selectedDeptOrder" class="w-full" placeholder="Department PO No." v-if="updateStatus" :disabled="updateStatus"/>

                    <label class="w-full font-semibold">Equipment:<span class="text-red-500">*</span> </label> 
                    <Dropdown class="w-full" v-model="selectedEquipment" filter :options="filteredEquipment" optionValue="id" optionLabel="name" placeholder="Select an equipment" @change="updateDialogData" v-if="!updateStatus" :disabled="updateStatus"/>

                    <InputText v-model="selectedEquipment" class="w-full" placeholder="Equipment name" v-if="updateStatus" :disabled="updateStatus"/>
                    
                    <label class="text-sm font-medium text-400 w-full m-0 p-0"> <span class="text-500">PO Date:</span> {{deptPoDate}}</label>
                </div>
                <div class="field col ">
                    <div class="flex justify-content-between flex-wrap ">
                        <div class="flex align-items-center justify-content-center">
                            <label class="w-full font-semibold">Delivered Location:<span class="text-red-500">*</span></label>
                        </div>
                        <div class="flex align-items-center justify-content-center mr-2">
                            <label class="w-full font-semibold">Qty:</label>
                            {{locationQuantity}}
                        </div>

                    </div>
                    <Dropdown class="w-full mt-2" v-model="selectedLocation" filter :options="deliveredLocations"  optionLabel="location.name" placeholder="Select delivery location" @change="updateDeliveredQty" :disabled="updateStatus" v-if="!updateStatus"/>

                    <InputText v-model="selectedLocation" class="w-full mt-2" placeholder="Installation location" v-if="updateStatus" :disabled="updateStatus"/>

                    <div class="flex justify-content-start flex-wrap mt-4">
                        <div class="flex align-items-center justify-content-center">
                            <label class="w-full font-semibold">Bill doc location:<span class="text-red-500">*</span></label>
                        </div>   
                    </div>
                    <div class="flex justify-content-start flex-wrap mt-1">
                        <div class="flex align-items-center justify-content-center w-full">
                            <InputText v-model="billLocation" class="w-full" placeholder="Installation short location"/>
                        </div>   
                    </div>               
                    
                </div>
            </div>

            <div class="formgrid grid">
                <div class="field col">
                    <label class="w-full font-semibold pt-2">Delivered Variant:<span class="text-red-500">*</span></label>
                    <Dropdown class="w-full" v-model="deliveredQty" filter :options="locationQty"  placeholder="Variant delivered" @change="updateModelSr" :disabled="updateStatus">
                        <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex align-items-center">
                                <div>{{ slotProps.value.pendingInstallation }}/ {{ slotProps.value.modelNo }} / {{ slotProps.value.partSerialNo }}</div>
                            </div>
                        </template>
                        <template #option="slotProps">
                            <div class="flex align-items-center">
                                <div>{{ slotProps.option.pendingInstallation }}/ {{ slotProps.option.modelNo }} / {{ slotProps.option.partSerialNo }}</div>
                            </div>
                        </template>
                    </Dropdown>
                </div>
                <div class="field col">
                    <label class="w-full font-semibold pt-2">Installed Qty:<span class="text-red-500">*</span></label>
                    <InputNumber class="w-full" v-model="installedQty" :min="1" :max="999999" showButtons :disabled="updateStatus"/>
                </div>
            </div>

            <ComponentOne v-if="cmcStatus">
                <div class="formgrid grid" >
                    <div class="field col">
                        <Fieldset>
                            <template #legend>
                                <div class="flex align-items-center pl-2">
                                    <i class="pi pi-spin pi-cog" style="font-size: 1.5rem"></i>
                                    <span class="font-bold ml-1"> CMC</span>
                                </div>
                            </template>

                            <DataTable :value="cmcs" showGridlines size="small" dataKey="id" :rows="10" scrollable scrollHeight="150px">

                                <Column field="year" header="Year"/>
                                <Column field="rate" header="Rate">
                                <template #body="slotProps">
                                    {{formatCurrency(slotProps.data.rate)}}
                                </template>
                                </Column>
                                <Column field="gst" header="GST(%)"/>
                            </DataTable>
                            
                        </Fieldset>
                    </div>
                </div>
            </ComponentOne>


            <ComponentTwo v-if="!cmcStatus">
            <div class="formgrid grid" >
                <div class="field col">
                    <Fieldset>
                        <template #legend>
                            <div class="flex align-items-center pl-2">
                                <i class="pi pi-spin pi-cog" style="font-size: 1.5rem"></i>
                                <span class="font-bold ml-1">Add CMC</span>
                            </div>
                        </template>

                        <div class="flex justify-content-end flex-wrap ">
                            <div class="flex align-items-center justify-content-center ">
                                <Button icon="pi pi-plus" severity="success" size="small" text raised @click="addNewCmc" disabled/>
                            </div>
                        </div>

                        <div class="flex" v-for="(item, index) in newCmcs" :key="index">
                            <div class="flex align-items-center justify-content-center w-8 mt-2">
                                <InputNumber class="w-full" v-model="cmcYear[index]" placeholder="Year of CMC" @input="updateNewCmcYear(index, $event)"/>
                            </div>
                            <div class="flex align-items-center justify-content-center mt-2 ml-1">
                                <InputNumber class="w-full" v-model="cmcCost[index]" placeholder="Cost of CMC" @input="updateNewCmcCost(index, $event)"/>
                            </div>
                            <div class="flex align-items-center justify-content-center mt-2 ml-1">
                                <InputNumber class="w-full" v-model="cmcGst[index]" placeholder="GST (%) on cost" @input="updateNewCmcGst(index, $event)"/>
                            </div>
                            <div class="flex align-items-center justify-content-centermt mt-2 ml-1">
                                <Button icon="pi pi-trash" text rounded severity="danger" @click="deleteCmcItem(index)"/>
                            </div>
                        </div>

                    </Fieldset>
                </div>
            </div>

            </ComponentTwo>

            <div class="formgrid grid">
                <div class="field col">
                    <label class="w-full font-semibold">Model No:</label>
                    <InputText v-model="modelNo" class="w-full" placeholder="Equipment Model No."/>
                </div>
                <div class="field col">
                    <label class="w-full font-semibold">Serial No:</label>
                    <InputText class="w-full" v-model="serialNo" placeholder="Serial/Part No."/>
                </div>
            </div>

            <div class="formgrid grid">
                <div class="field col">                                    
                    <label class="w-full font-semibold">Manufacturer:<span class="text-red-500">*</span></label>
                    <Dropdown editable class="w-full" v-model="manufacturer" filter :options="equipmentManufacturers" optionValue="id" optionLabel="name" placeholder="Manufacturer of equipment"/>
                </div>
                <div class="field col">
                    <label class="w-full font-semibold">Date:<span class="text-red-500">*</span></label>
                    <Calendar class="w-full" v-model="installationDate" placeholder="Installation date" dateFormat="dd/mm/yy" :disabled="updateStatus"/>
                </div>
            </div>

            <div class="formgrid grid">
                <div class="field col">
                    <label class="w-full font-semibold">AMS Representative:<span class="text-red-500">*</span></label>
                    <Dropdown editable class="w-full" v-model="installationEngineer" filter :options="engineers" optionValue="id" optionLabel="name" placeholder="Select representative" />
                </div>
            </div>

            <!-- <div class="flex"> -->
                <div class="flex  w-full">
                    <div class="surface-card shadow-2 p-3 border-round-lg  w-full mb-3">
                        <div class="flex justify-content-between flex-wrap ">
                            <div class="flex align-items-center justify-content-center font-semibold text-lg my-2 mx-2 ">                                        
                                        Items Description <span class="font-normal text-sm ml-2 text-400"> <span class="text-red-500">*</span>Add at-least 1 item </span>                                   
                            </div>
                            <div class="flex align-items-center justify-content-center ">
                                <Button label="Add item" severity="success" size="small" text raised @click="addItems" :disabled="updateStatus"/>
                            </div>
                        </div>
                        <div class="flex" v-for="(item, index) in itemsArr" :key="index">
                            <div class="flex align-items-center justify-content-center w-8 mt-2">
                                <InputText class="w-full" v-model="itemName[index]" placeholder="Item description" @change="updateItemName(index)"/>
                            </div>
                            <div class="flex align-items-center justify-content-center mt-2 ml-1">
                                <InputNumber class="w-full" v-model="itemQty[index]" placeholder="Quantity" @input="updateItemQty(index, $event)"/>
                            </div>
                            <div class="flex align-items-center justify-content-centermt mt-2 ml-1">
                                <Button icon="pi pi-trash" text rounded severity="danger" @click="deleteItem(index)"/>
                            </div>
                        </div>
                    </div>
                </div>
            <!-- </div> -->

            <div class="formgrid grid mt-1">
                <div class="field col">
                    <label class="w-full font-semibold">Remarks:</label>
                    <Textarea class="w-full" v-model="remarks" rows="5"  />
                </div>
            </div>
            <hr>
            <div class="mb-4">
                <label class="text-lg font-semibold mb-2">
                    User Details                                    
                </label>
            </div>
            <div class="formgrid grid">
                <div class="field col">
                    <label class="w-full font-semibold">Name:</label>
                    <InputText v-model="userName" class="w-full" placeholder="User full name"/>
                </div>
                <div class="field col">
                    <label class="w-full font-semibold">Contact:</label>
                    <InputMask v-model="userContact" mask="9999999999" placeholder="XXXXX-XXXXX" class="w-full"/>
                </div>
            </div>
            <template #footer>
                <div class="flex justify-content-end flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <Button label="Save" raised severity="success" size="small" @click="saveInstallation" class="mx-2" v-if="!updateStatus"></Button>
                        <Button label="Update" raised severity="success" size="small" @click="updateInstallation" class="mx-2" v-if="updateStatus"></Button>
                        <Button label="Cancel" text raised severity="secondary" size="small" @click="closeDialog"></Button>
                    </div>
                </div>
            </template>
        </Dialog>
        <!-- dialog end -->


        <Dialog :visible="confirmDeleteVisibility" modal :closable="false" header="Are you sure?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        
            <div class="flex">
                <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i></div>
                <div v-if="!deleteCmc" class="flex align-items-center justify-content-center ">
                    <p>
                        Are you sure you want to revert installation for {{name}}?
                    </p>
                </div>
                <div v-if="deleteCmc" class="flex align-items-center justify-content-center ">
                    <p>
                        Are you sure you want to delete servicing for {{name}}?
                    </p>
                </div>                              
            </div>
            <div class="flex justify-content-end flex-wrap">
                <Button v-if="!deleteCmc" class="my-1 py-2 mr-2 px-5" label="Yes" raised severity="danger" @click="deleteInstallation" />
                <Button v-if="deleteCmc" label="Delete" raised severity="danger" size="small" @click="deleteServicing" class="my-1 py-2 mr-2 px-5"></Button>
                <Button class="flex align-items-center justify-content-center my-1 px-5 " size="small" label="No" severity="secondary" text raised @click="closeDeleteDialog"></Button>
            </div>
        </Dialog>

        <CmcComponent :cmcData="servicingData" :visibility="serviceDialogVisibility" v-if="serviceComponent" :btnOption="btnOption" @close-cmc-dialog="closeCmcDialog(), fetchServicings()"></CmcComponent>

    </div>


</template>

<script>
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
import Fieldset from 'primevue/fieldset'
import Textarea from 'primevue/textarea'
import { addEquipInstallation, cancelEquipmentInstallation, deleteEquipmentInstallation, deleteServicings, deptOrderOnly, equipmentInstallationDashData, fetchEquipmentManufacturers, fetchInstallationEngineers, fetchPendingEquipmentsInstallation, getDeliveryLocations, getEquipmentInstallations, getServicings, updateEquipInstallation } from '@/services/apiService'
import ProgressSpinner from 'primevue/progressspinner'
import { FilterMatchMode, FilterOperator  } from 'primevue/api'
import MeterGroup from 'primevue/metergroup';
import Tag from 'primevue/tag'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import CmcComponent from './servicingComponent.vue'
import MultiSelect from 'primevue/multiselect'

export default {
    
    components:{
        Button,
        DataTable,
        Column,
        Dialog,
        InputText,
        Dropdown,
        Calendar,
        InputMask,
        InputNumber,
        Fieldset,
        Textarea,
        ProgressSpinner,
        MeterGroup,
        Tag,
    TabPanel,
        TabView,
        CmcComponent,
        MultiSelect,
    },

    data(){
        return{
            spinnerLoadingStatus:false,
            pendingInstallationCount:0,
            tableData:[],
            originalData:[],
            tableLoading:false,
            tableLoading2:false,
            dialogVisibility:false,
            dialogHeader:"Dialog header",
            deptPoDate:null,
            deptOrdersOnly:null,
            selectedDeptOrder:null,
            equipments:[],
            filteredEquipment:[],
            deliveredLocations:[],
            deliveredQty:null,
            tempDeliveredQty:[],
            locationQty:[],
            locationQuantity:0,
            engineers:[],
            selectedEquipment:null,
            selectedLocation:null,
            manufacturer:null,
            equipmentManufacturers:[],
            installationDate:null,
            modelNo:null,
            serialNo:null,
            billLocation:null,
            installationEngineer:null,
            itemsArr:[],
            itemName:[],
            itemQty:[],
            name:null,
            qty:0,
            cmcs:[],
            cmcStatus:false,
            cmcPresent:false,
            newCmcs:[],
            cmcYear:[],
            cmcCost:[],
            cmcGst:[],
            remarks:null,
            installationBtn:true,
            installedQty:1,
            filters:null,
            confirmDeleteVisibility:false,
            cancelDialogVisibility:false,
            cancelDialogHeader:'Dialog header',
            selectedEquipments:null,
            equipId:null,
            pendingInstallationMeter:[],
            servicingDue:0,
            servicingMeter:[],
            cmPendingBillCount:0,
            pendingBillExGst:0.00,
            pendingBillGst:0.00,
            locations:[],
            cmcStatusOptions:['No CMC', 'Completed', 'Pending'],
            billStatusOptions:['Pending', 'Completed'],
            cmcTypeOptions:['Annual CMC', 'Primitive', 'Breakdown'],
            startDate:null,
            endDate:null,
            servicingsData:null,
            table2Loading:false,
            filters2:null,
            deleteCmc:false,
            servicingId:null,
            serviceComponent:false,
            servicingData:null, 
            serviceDialogVisibility:false,  
            btnOption:null,  
            updateStatus:false,  
            installationId:null,   
        }
    },

    created() {
        this.initFilters();
    },
    mounted(){ 
        this.installationBtn = false;  
        this.fetchDashboardData();     
        this.fetchEquiupmentInstallations();
        getDeliveryLocations().then((res)=>{
            res.data.forEach(e => {
                this.locations.push(e.name);
            });                        
        }).catch((error)=>{
            this.showErrorToast(error.response.data);
        })
    },

    methods:{
        fetchDashboardData(){
            equipmentInstallationDashData().then((res)=>{                              

                let completedPerc = ((res.data[1].totalInstallations - res.data[0].pendingInstallation) / res.data[1].totalInstallations) * 100; 
                let pendingPerc = (res.data[0].pendingInstallation / res.data[1].totalInstallations) * 100;

                this.pendingInstallationMeter = [
                { label: 'Completed - '+(res.data[1].totalInstallations - res.data[0].pendingInstallation), color:'#a6eb9f', value: completedPerc }, 
                { label: 'Pending', color: '#ffaaaa', value: pendingPerc },
                ]

                this.pendingInstallationCount = res.data[0].pendingInstallation;

                // upcoming and over due servicing count
                 
                this.servicingDue = res.data.cmcDue + res.data.cmcOverDue;
                let cmcDuePerc = (res.data.cmcDue / this.servicingDue) * 100;
                let cmcOverDuePerc = (res.data.cmcOverDue / this.servicingDue) * 100;

                this.servicingMeter = [
                    {label:'Due in 14 days - '+res.data.cmcDue, color:'#ffcf78', value:cmcDuePerc},
                    {label:'Over due '+res.data.cmcOverDue, color:'#ffaaaa', value:cmcOverDuePerc},
                ]
                
                this.cmPendingBillCount = res.data.cmcPendingBillingCount;
                this.pendingBillExGst = res.data.pendingCmcExGst;
                this.pendingBillGst = res.data.pendingCmcGst;

            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            })
        },
        fetchEquiupmentInstallations(){  
            this.tableLoading = true;
            getEquipmentInstallations().then((res)=>{ 
                this.tableData = [];
                this.originalData = [];                
                this.tableData = res.data;
                this.originalData = res.data;
                this.tableLoading = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.tableLoading = false;
            })
        },
        fetchEquipmentsPendingInstallation(){
            this.equipments = [];
            this.filteredEquipment = [];
            this.tableLoading2 = true;
            fetchPendingEquipmentsInstallation().then((res)=>{
                res.data.forEach(e => {
                    if(e.deliveredQty.length > 0){
                        this.equipments.push(e);
                    }
                });               

                this.filteredEquipment = this.equipments               
                
                this.tableLoading2 = false;
                this.installationBtn = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            });
        },
        toggleTabs(event){
            if(event.index==0){
                this.fetchEquiupmentInstallations();
            }
            if(event.index==1){
                this.table2Loading = true
                this.fetchServicings();
            }
        },
        fetchServicings(){
            getServicings().then((res)=>{                    
                this.servicingsData = [];
                this.servicingsData = res.data;
                this.table2Loading = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.table2Loading = false;
            })
        },
        fetchDeptOrders(){
            deptOrderOnly([]).then((res)=>{
                this.deptOrdersOnly = res.data
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            })
        },
        filterEquipments(){
            if(this.selectedDeptOrder==null){
                this.filteredEquipment = this.equipments
                this.selectedEquipment = null
                // this.deptPoNo = null
                this.deptPoDate = null
                return 
            }

            this.deptPoDate = this.selectedDeptOrder.date
            this.filteredEquipment = []

            this.equipments.forEach(e => {
                if(e.poNo==this.selectedDeptOrder.poNo){
                    this.filteredEquipment.push(e);
                }
            });
            
        },
        showDialog(){
            this.fetchDeptOrders();
            this.fetchEquipmentsPendingInstallation();
            this.fetchEquipmentManufacturers();
            this.fetchAmsRepresentatives();
            this.tableLoading2 = false;
            this.dialogHeader = "Installation details";
            return this.dialogVisibility = true;
        },
        closeDialog(){

            this.selectedDeptOrder = null;
            this.billLocation = null;
            this.dialogVisibility = false;
            this.dialogHeader = null;
            this.selectedEquipment = null;
            this.selectedLocation = null;
            this.deliveredLocations = [];
            this.locationQty = [];
            this.locationQuantity = 0;

            this.manufacturer = null;
            this.installationDate = null;
            this.modelNo = null;
            this.serialNo = null;
            this.installationEngineer = null;
            this.itemsArr = [];
            this.itemName = [];
            this.itemQty = [];
            this.cmcStatus = false;
            this.deliveredQty = null;
            // this.deptPoNo = null;
            this.deptPoDate = null;
            this.remarks = null;
            this.userName = null;
            this.userContact = null;
            this.updateStatus = false;

            this.fetchEquipmentsPendingInstallation();
        },
        fetchEquipmentManufacturers(){
            return new Promise((resolve, reject) => {
                fetchEquipmentManufacturers().then((res)=>{
                    this.equipmentManufacturers = res.data;
                    resolve(this.equipmentManufacturers);
                }).catch((error)=>{
                    this.showErrorToast(error.response.data);
                    reject(error.response.data);
                })
            });
        },
        fetchAmsRepresentatives(){
            return new Promise((resolve, reject) => {
                fetchInstallationEngineers().then((res)=>{
                    this.engineers = res.data;
                    resolve(this.engineers);
                }).catch((error)=>{
                    this.showErrorToast(error.response.data);
                    reject(error.response.data);
                })
            });
        },
        updateDialogData(){    
            
            this.modelNo = null;
            this.serialNo = null;

            this.locationQuantity = 0;
            this.locationQty = [];

            this.selectedLocation = null;
            this.deliveredQty = null;
            
            this.equipments.every(e => {
                if(e.id == this.selectedEquipment){    
                    // this.deptPoNo = e.poNo;
                    // this.deptPoDate = e.poDate;
                    this.deliveredLocations = e.deliveryLocations;
                    this.tempDeliveredQty = e.deliveredQty;
                    this.cmcs = e.cmc;
                    if(e.cmc.length > 0){
                        this.cmcStatus = true;
                    }
                    if(e.cmc.length == 0){
                        this.cmcStatus = false;
                    }
                    return false;
                }
                return true;
            });
        },
        updateDeliveredQty(){ 
            
            this.modelNo = null;
            this.serialNo = null;
            
            this.locationQuantity = this.selectedLocation.quantity;
            this.deliveredQty = null;
            this.locationQty = [];
            this.tempDeliveredQty.forEach(e => {
                if(this.selectedLocation["location.locationId"] == e.locationId){
                    this.locationQty.push(e);
                }
            });            
                    
        },
        updateModelSr(){
            this.modelNo = this.deliveredQty.modelNo;
            this.serialNo = this.deliveredQty.partSerialNo;            
        },
        addItems(){
            this.itemsArr.push({
                name:null,
                qty:0
            });
        },
        updateItemName(index){            
            let item = this.itemsArr[index];
            item.name = this.itemName[index];            
        },
        updateItemQty(index, event){
            let item = this.itemsArr[index];
            item.qty = event.value;
        },
        deleteItem(index){
            this.itemsArr.splice(index, 1);
            this.itemName.splice(index, 1);
            this.itemQty.splice(index, 1);        
        },
        addNewCmc(){
            this.newCmcs.push({
                year:0,
                cost:0,
                gst:0,
            });
        },
        updateNewCmcYear(index, event){
            let cmc = this.newCmcs[index];
            cmc.year = event.value;
        },
        updateNewCmcCost(index, event){
            let cmc = this.newCmcs[index];
            cmc.cost = event.value;
        },
        updateNewCmcGst(index, event){
            let cmc = this.newCmcs[index];
            cmc.gst =  event.value;
        },
        deleteCmcItem(index){
            this.newCmcs.splice(index, 1);
            this.cmcYear.splice(index, 1);
            this.cmcCost.splice(index, 1);
            this.cmcGst.splice(index, 1);
        },
        saveInstallation(){
        
            if(!this.selectedEquipment==null || this.selectedLocation==null || this.manufacturer==null || this.installationDate==null || this.installationEngineer==null || this.deliveredQty == null || this.billLocation == null){
                return this.showErrorToast({'message':'Field marked with red * are mandatory!'});
            }
            if(this.itemsArr.length==0){
                return this.showErrorToast({'message':'Please add at-least 1 item description'});
            }

            this.spinnerLoadingStatus = true;

            const data = {
                'equipment':this.selectedEquipment,
                'deliveredLocation':this.selectedLocation,
                'billLocation':this.billLocation,
                'deliveredVariant':this.deliveredQty,
                'installedQty':this.installedQty,
                'modelNo':this.modelNo,
                'serialPartNo':this.serialNo,
                'manufacturer':this.manufacturer,
                'installationDate':this.installationDate.getDate()+'-'+(this.installationDate.getMonth()+1)+'-'+this.installationDate.getFullYear(),
                'installationEngineer':this.installationEngineer,
                'itemsDescriptionArr':this.itemsArr,
                'remarks':this.remarks,
                'newCmc':this.newCmcs,
                'rocCmc':this.cmcs,
                'userName':this.userName,
                'userContact':this.userContact,
            }            

            // this.spinnerLoadingStatus = true;
            this.closeDialog();

            addEquipInstallation(data).then((res)=>{
                this.showSuccessToast(res.data);
                // this.spinnerLoadingStatus = false;
                this.fetchEquiupmentInstallations();
                this.fetchEquipmentsPendingInstallation();
                this.spinnerLoadingStatus = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.spinnerLoadingStatus = false;
            });

            
        },
        updateInstallationDialog(data){

            this.fetchAmsRepresentatives().then(()=>{
                this.fetchEquipmentManufacturers().then(()=>{
                    this.installationId = data.id;
                    this.selectedDeptOrder = data.poNo;
                    this.selectedEquipment = data.item;
                    this.deptPoDate = data.poDate;
                    this.selectedLocation = data.location;
                    this.billLocation = data.billLocation;
                    this.installedQty = data.installedQty;
                    this.modelNo = data.modelNo;
                    this.serialNo = data.partSerialNo;
                    this.manufacturer = data.manufacturer.id;
                    this.installationDate = new Date(data.installationDate.split('-')[2], (data.installationDate.split('-')[1]-1), data.installationDate.split('-')[0]);
                    this.installationEngineer = data.installationEngineer.id;
                    this.remarks = data.remark;
                    this.userName = data.userName;
                    this.userContact = data.userContact;
        
                    this.updateStatus = true;
                    this.dialogHeader = "Update installation details";
                    this.dialogVisibility = true;
                })
            })

        },
        updateInstallation(){
            const data = {
                'modelNo':this.modelNo,
                'serialPartNo':this.serialNo,
                'manufacturer':this.manufacturer,
                'installationEngineer':this.installationEngineer,
                'remarks':this.remarks,
                'userName':this.userName,
                'userContact':this.userContact,
            }  
            this.closeDialog();
            this.spinnerLoadingStatus = true;
            updateEquipInstallation(this.installationId, data).then((res)=>{
                this.showSuccessToast(res.data);
                this.fetchEquiupmentInstallations();
                this.fetchEquipmentsPendingInstallation();
                // this.closeDialog();
                this.spinnerLoadingStatus = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.spinnerLoadingStatus = false;
            })
            
        },
        showDeleteDialog(data, option){            
            if(option===1){
                this.deleteCmc = false;
                this.equipId = data.id;
                this.name = data.item+' installed at '+data.location;
            }
            if(option===2){
                this.deleteCmc = true;
                this.servicingId = data.id;
                this.name = data.item+' located at '+data.location;
            }            
            this.confirmDeleteVisibility = true;
        },
        deleteInstallation(){
            this.spinnerLoadingStatus = true;
            deleteEquipmentInstallation(this.equipId).then((res)=>{
                this.showSuccessToast(res.data);   
                this.fetchEquiupmentInstallations();
                this.fetchEquipmentsPendingInstallation();                
                this.fetchEquipmentManufacturers();
                this.spinnerLoadingStatus = false;
                this.closeDeleteDialog();
                
            }).catch((error)=>{
                if(error.response.status==409){
                    this.showWarningToast(error.response.data)
                }
                else{
                    this.showErrorToast(error.response.data);
                }
                this.closeDeleteDialog();
                this.spinnerLoadingStatus = false;
            })
        },
        deleteServicing(){
            this.spinnerLoadingStatus = true;
            deleteServicings(this.servicingId).then((res)=>{
                this.showSuccessToast(res.data);
                this.fetchServicings();
                this.closeDeleteDialog();
                this.spinnerLoadingStatus = false;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.closeDeleteDialog();
                this.spinnerLoadingStatus = false;
            })
        },
        closeDeleteDialog(){
            this.confirmDeleteVisibility = false;
            this.equipId = null;
            this.servicingId = null;
            this.name = null;
        },
        cancelInstallation(){
            const newArr = this.selectedEquipments.map( e =>{
                return e.id
            })          
        
            cancelEquipmentInstallation(newArr).then((res)=>{
                this.showSuccessToast(res.data)   
                this.closeCancelDialog()           
            }).catch((error)=>{
                this.showErrorToast(error.response.data)              
            })          
        },
        updateCmcDialog(data){
            this.btnOption = 'Update';
            this.serviceComponent = true;
            this.serviceDialogVisibility = true;
            this.servicingData = data;
        },
        closeCmcDialog(){
            this.serviceDialogVisibility = false;
            this.serviceComponent = false;
        },
        
        showWarningToast(warning){
            this.$toast.add({ severity: 'warn', summary: 'Warning', detail:warning.message, life: 4000 });
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 2500 });
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 2500 });
        },
        formatCurrency(value) {
                return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        formatNumber(value) {
                return value.toLocaleString('en-IN');
        },
        getCmcSeverity(status){
            switch (status) {
                case 'No CMC':
                    return 'warning'
                case 'Completed':
                    return 'success';
                case 'Pending':
                    return 'danger';
                default:
                    break;
            }
        },
        getBillSeverity(status){
            switch (status) {
                case 'Pending':
                    return 'warning'
                case 'Completed':
                    return 'success';
                default:
                    break;
            }
        },
        getCmcTypeSeverity(type){
            switch (type) {
                case 'Annual CMC':
                    return 'success'
                case 'Primitive':
                    return 'warning';
                case 'Breakdown':
                    return 'danger';
                default:
                    break;
            }
        },
        exportCSV() {
            this.$refs.installationsList.exportCSV();
        },
        exporServicingtCSV(){
            this.$refs.servicingsList.exportCSV();
        },
        globalFilter(){            
            var temp = [];
            this.originalData.filter((e)=>{
                if(e.nextCmc.cmcDate){
                    var cmcDate = e.nextCmc.cmcDate.split("/");
                    
                    var nextCmcDate = new Date(cmcDate[2], (cmcDate[1]-1), cmcDate[0]);
                    if ((this.startDate!=null ? (nextCmcDate >= this.startDate) : true) && (this.endDate!=null ?  (nextCmcDate <= this.endDate) : true)){
                        temp.push(e);
                    }
                }                
            });            
            this.tableData = temp;            
        },
        clearFilter(){
            this.tableData = this.originalData;
            this.startDate = null;
            this.endDate = null;
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                location: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.IN }] },   
                item: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },   
                partSerialNo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                poNo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                'nextCmc.status': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }, 
                
            };

            this.filters2 = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                location: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },   
                item: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                partSrNo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                billStatus: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }, 
                serviceType: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                order: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            }
        },
        formatDate(value) {
            return value.toLocaleString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
    },
    

}
</script>

<style>


hr.hr-style{
    border-top: 2px dashed #d5d8dc;
}
</style>